import { FC } from 'react';
import { Box, Container } from '@mui/material';
import { APP } from 'config';
import { Header as HeaderV2 } from '../../header-v2/header.component';
import Header from '../../header/Header/Header';

export const Base: FC = ({ children }) => {
  return (
    <Box>
      {APP.envName === 'prod' ? <Header /> : <HeaderV2 />}

      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          pt: 2,
          pb: 10,
          '&.MuiContainer-maxWidthLg': {
            maxWidth: APP.layout.container.maxWidth,
          },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};
